import { render, staticRenderFns } from "./FleetView.vue?vue&type=template&id=0953bfc0&scoped=true"
import script from "./FleetView.vue?vue&type=script&lang=js"
export * from "./FleetView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0953bfc0",
  null
  
)

export default component.exports